import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

const initialState = {
  isCustomerSelectPackage: false,
  selectedPackage: {},
};

const SalePackagesBlockSlice = createSlice({
  name: 'SalePackagesBlock',
  initialState: initialState,
  reducers: {
    resetSalePackagesBlock: (state) => initialState,
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setRouterParams: (state, action) => {
      state.selectedPackage.isSelectedCellcomRouter = action.payload;
      state.selectedPackage.selectedRouterName = action.payload
        ? state.selectedPackage.cellcomRouterName
        : state.selectedPackage.foreignRouterName;
    },
    setIsCustomerSelectPackage: (state, action) => {
      state.isCustomerSelectPackage = true;
    },
    reportDWH: (state, action) => {},
  },
  extraReducers: {},
});

export const {resetSalePackagesBlock, setSelectedPackage, setRouterParams, reportDWH, setIsCustomerSelectPackage} =
  SalePackagesBlockSlice.actions;

export default SalePackagesBlockSlice.reducer;
